/**
 * @group Feature Flags
 * @summary Feature flags for controlling application features.
 * 
 * @remarks
 * These are compile-time constants requiring code changes to modify.
 * Feature flags control feature availability across mobile and web applications.
 * 
 * @see Issue #128 - AI scanning temporarily disabled due to SDK bug
 * 
 * @example
 * ```typescript
 * import { FEATURE_FLAGS } from '@shared/constants';
 * 
 * if (FEATURE_FLAGS.ENABLE_AI_SCANNING) {
 *   // Show scanner UI
 * }
 * ```
 */
export const FEATURE_FLAGS = {
  /**
   * Controls availability of ShenAI vitals scanning functionality.
   * 
   * When false:
   * - Scanner buttons are hidden from UI
   * - Scanner routes show error messages
   * - Token generation API returns 503
   * - All ShenAI code remains in place for future re-enablement
   * 
   * @default true - Disabled due to critical SDK bug (Issue #128)
   */
  ENABLE_AI_SCANNING: true,
} as const;
